import React, { useEffect, useMemo, useState } from "react";
import RGL, { WidthProvider } from "react-grid-layout";
import { Box, Grid, IconButton, InputBase, Paper } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import {
  DeleteUserDashboard,
  SetFavoriteReport,
  UpdateUserDashboardsConfig,
} from "../../../services/dashboard.service";

import styled from "styled-components";
import Layout, { getContent, Root } from "@mui-treasury/layout";
import CssBaseline from "@material-ui/core/CssBaseline";
import { v4 as uuidv4 } from "uuid";
import { ApiResultModel } from "../../../models/common.model";

import SearchIcon from "@mui/icons-material/Search";
import TabPanelCmp from "../../../components/tabPanel/tabPanelCmp_V2";
import {
  GetGroupsWithSubReportsResponse,
  Reports,
} from "../../../models/pBIReport.model";
import { GetGroupsWithSubReports } from "../../../services/pBIReport.service";
import { getgroups } from "process";

import { setDashboardLoader } from "../../../redux/dashboardLoader/dashboardLoaderAction";
import { SetCurrentTabIndex } from "../../../redux/favouriteDashboardSearch/favouriteDashboardSearchAction";

//Styles
import "./styles.css";
import { GetSideMenu } from "../../../models/security.model";
import { GetMenus } from "../../../services/security.service";
import { getJwtToken } from "../../../services/auth.service";
import { useHistory, withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
const Content = getContent(styled);
const scheme = Layout();

scheme.configureHeader((builder) => {
  builder
    .create("whatever_id")
    .registerConfig("xs", {
      position: "sticky",
    })
    .registerConfig("md", {
      position: "relative", // won't stick to top when scroll down
    });
});

let getGroupsWithSubReportsResult: GetGroupsWithSubReportsResponse[] = [];
const FavouriteDashboardSearch = ({ favouriteDashboardSearch }: FavouriteDashboardSearchPropsInterface) => {
  const [
    getFilteredGroupsWithSubReportsResult,
    setGetFilteredGroupsWithSubReportsResult,
  ] = useState<GetGroupsWithSubReportsResponse[]>();
  let { data, isLoading, refetch } = useQuery<
    GetGroupsWithSubReportsResponse[]
  >(
    "GetGroupsWithSubReports",
    (): Promise<GetGroupsWithSubReportsResponse[]> => {
      return GetGroupsWithSubReports();
    },
    {
      onSuccess: (data) => {
        getGroupsWithSubReportsResult = Object.assign([], data);
        setGetFilteredGroupsWithSubReportsResult(data);
      },
    }
  );

  let {
    data: sideMenu,
    isLoading: sideMenuLoading,
    refetch: sideMenuRefetch,
  } = useQuery<GetSideMenu>(
    "GetSideMenus",
    (): Promise<GetSideMenu> => {
      return GetMenus();
    },
    { enabled: getJwtToken() != null }
  );

  const SetFavoriteReportMutation = useMutation(SetFavoriteReport, {
    onSuccess: (result: ApiResultModel<boolean>) => {
      if (result.isSuccess == true) {
        refetch();
        sideMenuRefetch();
      }
    },
    onError: () => { },
  });

  //UseEffects
  const [searchValue, setSearchValue] = useState<string>("");
  const [currentTabNumber, setCurrentTabNumber] = useState<number>(favouriteDashboardSearch.tabIndex);
  const tabs: any[] = [];

  useEffect(() => {
    console.log(favouriteDashboardSearch);
  }, [favouriteDashboardSearch]);

  React.useEffect(() => {
    if (tabs?.length > 0) {
      let indexOfMaxTotalCountValue = 0;
      let maxValue = 0;
      tabs.map((item: any, idx: any) => {
        if (item.totalFoundCount > maxValue) {
          maxValue = item.totalFoundCount;
          indexOfMaxTotalCountValue = idx;
        }
      });

      setCurrentTabNumber(indexOfMaxTotalCountValue);
    }
  }, [searchValue]);

  //Events Handlers
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let searchedValue = e.target.value.trim().toLocaleLowerCase();

    let getGroupsWithSubReportsResultTemp = Object.assign(
      [],
      getGroupsWithSubReportsResult
    );
    let filteredGetGroupsWithSubReportsResultTemp: GetGroupsWithSubReportsResponse[] = [];

    if (
      getGroupsWithSubReportsResultTemp &&
      getGroupsWithSubReportsResultTemp.length > 0 &&
      searchedValue
    ) {
      getGroupsWithSubReportsResultTemp?.map(
        (item: GetGroupsWithSubReportsResponse, idx: any) => {
          let itemTemp = Object.assign([], item);
          itemTemp.reports = item.reports.filter((f) =>
            f.title.includes(searchedValue)
          );
          filteredGetGroupsWithSubReportsResultTemp.push(itemTemp);
        }
      );

      setGetFilteredGroupsWithSubReportsResult(
        filteredGetGroupsWithSubReportsResultTemp
      );
    } else {
      setGetFilteredGroupsWithSubReportsResult(
        Object.assign([], getGroupsWithSubReportsResult)
      );
    }

    setSearchValue(searchedValue);
  };

  const handleOnPinnIconClick = (dashboardItem: Reports) => {
    SetFavoriteReportMutation.mutate({ id: dashboardItem.id });
  };

  const dispatch = useDispatch();
  const handleOnTabChange = (index: any) => {
    dispatch(SetCurrentTabIndex({ tabIndex: index }));
  }

  //The page components
  const DashboardParent = (reports: any) => {
    let currentReports = reports?.reports as Reports[];
    return (
      <>
        {currentReports?.length > 0 && (
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 1, sm: 1, md: 6, lg: 12 }}
            style={{ paddingTop: "30px", marginTop: "-40px" }}
          >
            {currentReports.map((item: Reports, idx: any) => (
              <>
                <Grid item sm={6} xs={12} md={4} lg={3} xl={3} >
                  <DashboardItem
                    OnPinnIconClick={handleOnPinnIconClick}
                    DashboardItem={item}
                  />
                </Grid>
              </>
            ))}
          </Grid>
        )}
      </>
    );
  };

  getFilteredGroupsWithSubReportsResult?.map(
    (item: GetGroupsWithSubReportsResponse, idx: number) => {
      let totalFoundReport = item?.reports?.length;
      if (totalFoundReport !== 0) {
        tabs.push({
          id: idx,
          key: idx + "",
          title: item.title,
          totalFoundCount: totalFoundReport,
          // icon: <AssignmentIndOutlinedIcon />,
          child: <DashboardParent reports={item.reports} />,
        });
      }
    }
  );

  const [layout, setLayout] = useState<any[]>();
  return (
    <div className="favourite-dashboard-search" style={{ direction: "rtl" }}>
      <Root scheme={scheme}>
        <CssBaseline />
        <div>
          <Content>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 1, sm: 1, md: 6, lg: 12 }}
              style={{ paddingTop: "30px", marginRight: "20px" }}
            >
              <Grid item xs={3}>
                <Paper
                  elevation={0}
                  style={{
                    border: "1px solid #DAE0E4",
                    display: "flex",
                  }}
                  square={false}
                >
                  <InputBase
                    sx={{
                      ml: 1,
                      flex: 1,
                      paddingX: "16px",
                      input: {
                        color: "#757575",
                        "&::placeholder": {
                          // <----- Add this.
                          opacity: 1,
                        },
                      },
                    }}
                    placeholder="جستجو"
                    // inputProps={{ 'aria-label': 'جستجو' }}
                    onChange={handleSearchInput}
                  />
                  <IconButton
                    type="button"
                    sx={{ color: "#9AAFC4" }}
                    aria-label="search"
                  >
                    <SearchIcon style={{ fontSize: "24px" }} />
                  </IconButton>
                </Paper>
              </Grid>
            </Grid>{" "}
            <Grid item xs={12}>
              <TabPanelCmp
                tab={tabs}
                colorTab={"#01af43"}
                currentTabNumber={currentTabNumber}
                onChange={(index: any) => handleOnTabChange(index)}
              />
            </Grid>
          </Content>
        </div>
        {/* <Footer>Footer</Footer> */}
      </Root>
    </div>
  );
};

//The page components
interface DashboardItemPropsInteface {
  OnPinnIconClick: any;
  DashboardItem: Reports;
}

const DashboardItem = ({
  OnPinnIconClick,
  DashboardItem,
}: DashboardItemPropsInteface) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClickDashboard = (url: any) => {
    dispatch(setDashboardLoader({ BIURL: url }));
    history.push("/dashboadLoader");
  };

  const handlePinnIconClick = (e: any, dashboardItem: any) => {
    e.stopPropagation();
    OnPinnIconClick(dashboardItem);
  };

  return (
    <div
      className={ ` dashboard-item-div  ${DashboardItem.isFavorite ? '' :'favoriteIcon'}`}
      onClick={() => {
        handleClickDashboard(DashboardItem.url);
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={12}
        className="dashboard-item-main-grid "
        alignItems="center"
        justifyContent="center"
       
      >

      

        <Grid item sm={10} style={{ textAlign: 'right' }} className="dashboard-item-sub-grid-span">
          
          <img
            src={`images/dashboard/search/sample-${DashboardItem.pbiReportTypeId}.png`}
            className="iconeSide dashboard-img"
            style={{ display:'inline-block' }}
            />
            {DashboardItem.title}
        
        </Grid>
        <Grid item sm={2} style={{ textAlign: 'left' }} >
          <Box display="flex" justifyContent="flex-end">
            <div
              style={{ zIndex: 1000 }}
              onClick={(e) => handlePinnIconClick(e, DashboardItem)}

            >

              {
                DashboardItem.isFavorite ? <StarIcon className="StarIcon"  style={{marginLeft:'10px'}}/> :<StarBorderIcon className="StarBorderIcon"  style={{marginLeft:'10px'}}/>
              }
            </div>
          </Box>
        </Grid>
      </Grid>


    </div>
  );
};


interface FavouriteDashboardSearchPropsInterface {
  favouriteDashboardSearch: any
}
const mapStateToProps = ({ favouriteDashboardSearch }: FavouriteDashboardSearchPropsInterface) => {
  return {
    favouriteDashboardSearch
  };
};

export default withRouter(connect(mapStateToProps)(FavouriteDashboardSearch));
